import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function X($$anchor, $$props) {
	const iconNode = [
		["path", { "d": "M18 6 6 18" }],
		["path", { "d": "m6 6 12 12" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiWC5zdmVsdGUiXSwic291cmNlc0NvbnRlbnQiOlsiPHNjcmlwdCBsYW5nPVwidHNcIj5cbiAgaW1wb3J0IEljb24gZnJvbSAnLi9JY29uLnN2ZWx0ZSc7XG4gIGNvbnN0IGljb25Ob2RlOiBbc3RyaW5nLCBSZWNvcmQ8c3RyaW5nLCBzdHJpbmc+XVtdID0gW1tcInBhdGhcIiwgeyBcImRcIjogXCJNMTggNiA2IDE4XCIgfV0sIFtcInBhdGhcIiwgeyBcImRcIjogXCJtNiA2IDEyIDEyXCIgfV1dO1xuICBsZXQgcmVzdCA9ICRwcm9wcygpO1xuPC9zY3JpcHQ+XG48SWNvbiB7aWNvbk5vZGV9IHsuLi5yZXN0fSAvPlxuIl0sIm1hcHBpbmdzIjoiOztPQUNTLElBQUksTUFBTSxlQUFlOzs2Q0FEbEMsQ0FBQztPQUVPLFFBQTRDO0dBQUssTUFBTSxJQUFJLEdBQUcsRUFBRSxZQUFZO0dBQU0sTUFBTSxJQUFJLEdBQUcsRUFBRSxZQUFZOzs7S0FDL0csSUFBSTs7Ozs7Ozs7UUFFVyxJQUFJOztBQUQxQixDQUFDIn0=